/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Type_ChiropracticInputs */

const en_service_type_chiropractic = /** @type {(inputs: Service_Type_ChiropracticInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chiropractic`)
};

const pl_service_type_chiropractic = /** @type {(inputs: Service_Type_ChiropracticInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chiropraktyka`)
};

/**
* | output |
* | --- |
* | "Chiropractic" |
*
* @param {Service_Type_ChiropracticInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const service_type_chiropractic = /** @type {((inputs?: Service_Type_ChiropracticInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Type_ChiropracticInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_service_type_chiropractic(inputs)
	return en_service_type_chiropractic(inputs)
});